import React from 'react'

// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'
import _ from 'lodash'
// import MCIcon from '@expo/vector-icons/MaterialCommunityIcons'
import XCustomHeader from 'xui/components/XCustomHeader'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
// import SRowItem from '../../components/renderRowLeftAndRight'
import BaseSelectedAddOnView from 'x/modules/subscription/BaseSelectedAddOnView'
import * as util from 'x/utils/util'
import * as xFmt from 'x/utils/formatter'
import { COLORS } from 'x/config/styles'
import XCard from 'xui/components/XCard'
import XText from 'xui/components/XText'
import VStack from 'xui/components/VStack'
import { TouchableOpacity } from 'react-native'
import HStack from 'xui/components/HStack'
import XIcon from 'xui/components/XIcon'
import { ISelectedAddOn } from 'x/modules/subscription/BasePaymentSubscriptionView'
import { SubscriptionPackageListItems } from 'x/index'
import XOrderCountHistory from './XOrderCountHistory'

export default abstract class BaseUISelectedAddOnView extends BaseSelectedAddOnView {
  _renderHeader = () => {
    const { addOnList } = this.state
    // console.log('addOnList => ', addOnList)
    let title = 'เลือกแพ็กเสริม'
    if (!_.isNil(addOnList) && addOnList.length > 0) {
      let key = addOnList[0]?.item_subtype
      // if order [0] sku is null
      if (addOnList[0].sku === null) {
        key = addOnList[1]?.item_subtype
      }

      if (!_.isNil(key)) {
        title = `เลือกแพ็กเสริม${this._getLabelUnit(key)}`
      }
    }

    return (
      <XCustomHeader
        title={title}
        headerLeftProps={{ backIcon: true, onPressItem: () => this.goBack() }}
        // renderHeaderRight={this._renderHeaderRight}
      />
    )
  }

  _hasSelectedAddOn = () => {
    const { selectedAddOnlist } = this.state
    if (_.isNil(selectedAddOnlist)) {
      return false
    }
    let hasSelected = false
    selectedAddOnlist.forEach((addOn) => {
      if (!_.isNil(addOn) && !_.isNil(addOn.sku) && addOn.qty > 0) {
        hasSelected = true
      }
    })
    return hasSelected
  }

  _renderFooter = () => {
    const { isEditing } = this.state
    // console.log('isEditing => ', isEditing)
    // console.log('selectedAddOnlist => ', selectedAddOnlist)
    const isDisabled = !isEditing
    return (
      <TouchableOpacity
        onPress={() => this._onPressFooter()}
        disabled={isDisabled}
        style={{
          borderRadius: 90,
          height: 43,
          backgroundColor: isDisabled ? COLORS.BG_LIGHT_GREY : COLORS.APP_MAIN,
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: 2,
          marginLeft: 2,
          marginBottom: 2,
        }}
      >
        <XText color={isDisabled ? COLORS.TEXT_INACTIVE : COLORS.WHITE} bold>
          ยืนยัน
        </XText>
      </TouchableOpacity>
    )
    // return (
    //   <XButton
    //     mb='1'
    //     mx='1'
    //     disabled={_.isNil(selectedAddOnlist)}
    //     onPress={() => this._onPressFooter()}
    //     style={{ backgroundColor: COLORS.BG_LIGHT_GREY }}>
    //     ยืนยัน
    //   </XButton>
    // )
  }

  _renderSelectedOrderQty = () => {
    const { selectedAddOnlist, addOnList } = this.state
    // addOnList[0].sku is order_quota
    if (addOnList.length > 0 && addOnList[0].sku === null) {
      const addOn: ISelectedAddOn | null = !_.isNil(selectedAddOnlist) && selectedAddOnlist.length > 0 ? selectedAddOnlist[0] : null

      if (_.isNil(selectedAddOnlist) || _.isNil(addOn)) {
        return null
      }

      // console.log('addOn => ', addOn)
      const selectedAddOn: SubscriptionPackageListItems = this._getSelectedAddOn(
        !_.isNil(addOn) && _.has(addOn, 'sku') && !_.isNil(addOn.sku) ? addOn.sku : null
      )
      // console.log('selectedAddOn => ', selectedAddOn)
      const isCanMinus = _.isNil(addOn) ? false : addOn.qty > 1
      const isCanPlus = true

      const onPressMinusBtn = () => {
        const newselectedAddOnlist = _.cloneDeep(selectedAddOnlist)
        if (newselectedAddOnlist[0].qty === 1) {
          return
        }
        newselectedAddOnlist[0].qty -= 1
        this.setState({ selectedAddOnlist: newselectedAddOnlist, isEditing: true })
      }
      const onPressPlusBtn = () => {
        const newselectedAddOnlist = _.cloneDeep(selectedAddOnlist)
        newselectedAddOnlist[0].qty += 1
        this.setState({ selectedAddOnlist: newselectedAddOnlist, isEditing: true })
      }
      return (
        <VStack w='full' mt='2' p='2'>
          <XText variant='active' bold>
            {`${selectedAddOn.name} x ${addOn.qty}`}
          </XText>
          <VStack mt='2'>
            <HStack flex={1} justifyContent='flex-start' alignItems='center'>
              <TouchableOpacity
                disabled={!isCanMinus}
                onPress={() => {
                  if (!isCanMinus) {
                    return
                  }
                  onPressMinusBtn()
                }}
              >
                <XIcon name='minus-circle' family='AntDesign' opacity={0.3} color={isCanMinus ? COLORS.RED : COLORS.TEXT_INACTIVE} />
              </TouchableOpacity>

              <XText w='20' textAlign='center' bold>
                {addOn.qty}
              </XText>
              <TouchableOpacity
                disabled={false}
                onPress={() => {
                  if (!isCanPlus) {
                    return
                  }
                  onPressPlusBtn()
                }}
              >
                <XIcon name='plus-circle' family='AntDesign' opacity={0.3} color={isCanPlus ? COLORS.GREEN : COLORS.TEXT_INACTIVE} />
              </TouchableOpacity>
            </HStack>
          </VStack>
        </VStack>
      )
    }
    return null
  }

  _renderSelectedAddOnByListView = () => {
    const { addOnList, selectedAddOnlist } = this.state
    const addOn: ISelectedAddOn | null = !_.isNil(selectedAddOnlist) && selectedAddOnlist.length > 0 ? selectedAddOnlist[0] : null
    const key = addOnList[0]?.item_subtype
    let unitLabel = 'ออเดอร์'
    if (!_.isNil(key)) {
      unitLabel = this._getLabelUnit(key)
    }

    const selectedAddOn: SubscriptionPackageListItems = this._getSelectedAddOn(
      !_.isNil(addOn) && _.has(addOn, 'sku') && !_.isNil(addOn.sku) ? addOn.sku : null
    )
    let textLabel = `เลือกแพ็กเสริมเพิ่ม${unitLabel}`
    if (!_.isNil(selectedAddOn) && _.has(selectedAddOn, 'sku') && !_.isNil(selectedAddOn.sku)) {
      textLabel = `${selectedAddOn.name} (${xFmt.formatCurrency(selectedAddOn.price_with_vat)}/รอบบิล)`
    }
    return (
      <VStack w='full'>
        <XText fontSize='lg' bold>
          {`เลือกแพ็กเสริมเพิ่ม${unitLabel}....`}
        </XText>
        <TouchableOpacity
          onPress={() => this._navToSelectedAddOnListView()}
          style={{ borderRadius: 90, backgroundColor: COLORS.APP_MAIN, alignItems: 'center', justifyContent: 'center' }}
        >
          <HStack py='2' alignItems='center' justifyContent='center' w='full'>
            <HStack flex={1} justifyContent='center' alignItems='center'>
              <XText color={COLORS.WHITE} bold>
                {textLabel}
              </XText>
            </HStack>
            <HStack w='10'>
              <XIcon name='arrow-forward' color={COLORS.WHITE} />
            </HStack>
          </HStack>
        </TouchableOpacity>
      </VStack>
    )
  }

  _renderSelectedAddOnByBtn = () => {
    const { selectedAddOnlist } = this.state
    if (_.isNil(selectedAddOnlist) || selectedAddOnlist.length === 0) {
      return null
    }

    return (
      <VStack w='full'>
        {selectedAddOnlist.map((addOn, idx) => {
          const { sku, qty } = addOn
          const selectedAddOn: SubscriptionPackageListItems = this._getSelectedAddOn(sku)
          if (_.isNil(selectedAddOn)) {
            return null
          }
          const isCanMinus = qty > 0
          const isCanPlus = true
          return (
            <VStack w='full' mt='2' p='2' key={addOn.sku}>
              <XText variant='active' bold>
                {selectedAddOn.name}
              </XText>
              <VStack mt='2'>
                <HStack flex={1} justifyContent='flex-start' alignItems='center'>
                  <TouchableOpacity
                    style={{ height: 50, width: 50, alignItems: 'center', justifyContent: 'center' }}
                    disabled={!isCanMinus}
                    onPress={() => {
                      if (!isCanMinus) {
                        return
                      }
                      this._onPressMinusBtnByAddOnPackage(idx)
                    }}
                  >
                    <XIcon name='minus-circle' family='AntDesign' opacity={0.3} color={isCanMinus ? COLORS.RED : COLORS.TEXT_INACTIVE} />
                  </TouchableOpacity>

                  <XText w='20' textAlign='center' bold>
                    {addOn.qty}
                  </XText>
                  <TouchableOpacity
                    style={{ height: 50, width: 50, alignItems: 'center', justifyContent: 'center' }}
                    disabled={false}
                    onPress={() => {
                      if (!isCanPlus) {
                        return
                      }
                      this._onPressPlusBtnByAddOnPackage(idx)
                    }}
                  >
                    <XIcon name='plus-circle' family='AntDesign' opacity={0.3} color={isCanPlus ? COLORS.GREEN : COLORS.TEXT_INACTIVE} />
                  </TouchableOpacity>
                </HStack>
                {/* <HStack w='full'>
                  <HStack flex={1}>
                    <XText>{`จำนวน ${addOn.billing_cycle} รอบบิล`}</XText>
                  </HStack>
                  <VStack w='24' justifyContent='flex-end'>
                    <XText bold textAlign='right'>
                      {xFmt.formatCurrency(selectedAddOn.price_with_vat * addOn.billing_cycle)}
                    </XText>
                  </VStack>
                </HStack> */}
              </VStack>
            </VStack>
          )
        })}
      </VStack>
    )
  }

  _renderSelectedAddOn = () => {
    const { addOnList } = this.state
    // console.log('addOnList / => ', addOnList)
    if (_.isNil(addOnList)) {
      return null
    }
    // addOnList[0].sku is order_quota
    if (addOnList.length > 0 && addOnList[0].sku === null) {
      return this._renderSelectedAddOnByListView()
    }
    return this._renderSelectedAddOnByBtn()
  }

  _renderBillingCycle = () => {
    const { selectedPackage, subscriptionPackageList, selectedAddOnlist, mode } = this.state
    const isDisabled = !this._hasSelectedAddOn()
    if (_.isNil(selectedPackage) || _.isNil(subscriptionPackageList) || _.isNil(selectedAddOnlist) || isDisabled) {
      return null
    }
    // console.log('selectedAddOnlist => ', selectedAddOnlist)
    const { subscription } = this.props
    const addOn = !_.isNil(selectedAddOnlist) && selectedAddOnlist.length > 0 ? selectedAddOnlist[0] : null
    const selectedAddOn = this._getSelectedAddOn(!_.isNil(addOn) && _.has(addOn, 'sku') && !_.isNil(addOn.sku) ? addOn.sku : null)
    const remainingBillingCycle = subscription.has('remaining_billing_cycle') ? subscription.get('remaining_billing_cycle') : null
    const isLifeTime = !_.isNil(selectedAddOn) && _.has(selectedAddOn, 'item_type') && selectedAddOn.item_type === 'addon_lifetime'
    let maxBillingCycle =
      !_.isNil(remainingBillingCycle) && remainingBillingCycle > 0 ? remainingBillingCycle : selectedPackage.billing_cycle
    let startBillingCycle = !_.isNil(addOn) && _.has(addOn, 'billing_cycle') ? addOn.billing_cycle : maxBillingCycle
    if (mode === 'continue_package') {
      maxBillingCycle = selectedPackage.billing_cycle
      if (isLifeTime) {
        startBillingCycle = selectedPackage.billing_cycle
      }
    }
    console.log('_renderBillingCycle selectedAddOnlist => ', selectedAddOnlist)
    console.log('_renderBillingCycle maxBillingCycle => ', maxBillingCycle)
    console.log('_renderBillingCycle startBillingCycle => ', startBillingCycle)

    let billingCycleLabel = util.getStartAndEndBillingCycle(subscriptionPackageList, startBillingCycle, mode)
    if (mode === 'add_on') {
      billingCycleLabel = util.getAddOnModeStartAndEndBillingCycle(subscriptionPackageList, startBillingCycle)
    }

    const isCanMinus = !isLifeTime && startBillingCycle > 1
    const isCanPlus = !isLifeTime && startBillingCycle < maxBillingCycle

    if (_.isNil(selectedAddOnlist) || selectedAddOnlist.length === 0) {
      return null
    }
    // console.log('mode =<> ', mode)
    // if (mode === 'add_on' || mode === 'upgrade') {
    //   const LOCAL_DATE_FORMAT = 'D MMM YYYY'
    //   const startBillingDate = subscription.has('start_billing_date')
    //     ? subscription.get('start_billing_date')
    //     : subscription.get('startBillingDate')
    //   const endBillingDate = subscription.has('end_billing_date')
    //     ? subscription.get('end_billing_date')
    //     : subscription.get('endBillingDate')
    //   const txtEndBillingDate = dayjs(endBillingDate, CONS.SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    //   const txtStartBillingDate = dayjs(startBillingDate, CONS.SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    //   billingCycleLabel = `${txtStartBillingDate} - ${txtEndBillingDate}`
    // }
    return (
      <VStack bgColor='#D9EAF3' w='full' mt='2' p='2'>
        <XText variant='active' bold>
          จำนวนรอบบิล
        </XText>
        <VStack mt='2'>
          <HStack flex={1} justifyContent='flex-start' alignItems='center'>
            {isLifeTime ? null : (
              <TouchableOpacity
                disabled={!isCanMinus}
                onPress={() => {
                  if (!isCanMinus) {
                    return
                  }
                  this._onPressMinusBtn()
                }}
              >
                <XIcon name='minus-circle' family='AntDesign' opacity={0.3} color={isCanMinus ? COLORS.RED : COLORS.TEXT_INACTIVE} />
              </TouchableOpacity>
            )}
            <XText w='20' textAlign={isLifeTime ? 'left' : 'center'} bold>
              {`${startBillingCycle}/${maxBillingCycle}`}
            </XText>
            {isLifeTime ? null : (
              <TouchableOpacity
                disabled={false}
                onPress={() => {
                  if (!isCanPlus) {
                    return
                  }
                  this._onPressPlusBtn()
                }}
              >
                <XIcon name='plus-circle' family='AntDesign' opacity={0.3} color={isCanPlus ? COLORS.GREEN : COLORS.TEXT_INACTIVE} />
              </TouchableOpacity>
            )}
          </HStack>
          <VStack mt='1'>
            {/* <XText variant='inactive'>{`จำนวน ${selectedBillingCycle} รอบบิล`}</XText> */}
            <XText variant='inactive'>{`${billingCycleLabel}`}</XText>
          </VStack>
        </VStack>
      </VStack>
    )
  }

  _renderResultAddOn = (addOn: ISelectedAddOn) => {
    const selectedAddOn: SubscriptionPackageListItems = this._getSelectedAddOn(addOn.sku)
    const price = selectedAddOn.price_with_vat * addOn.billing_cycle * addOn.qty
    const key = selectedAddOn.item_subtype
    const unit = util.getUnitNameByDataJsonKey(key)
    const sumUnitTotal = selectedAddOn.data_json[key] * addOn.qty
    if (_.isNil(sumUnitTotal) || sumUnitTotal === 0) {
      return null
    }
    return (
      <VStack w='full' key={addOn.sku} borderBottomColor={COLORS.TEXT_INACTIVE} borderBottomWidth='1' py='2'>
        <XText variant='active'>{`เพิ่ม ${xFmt.formatDecimal(sumUnitTotal)} ${unit}`}</XText>
        {/* <XText variant='inactive'>{`${xFmt.formatCurrency(selectedAddOn.price_with_vat)}/รอบบิล`}</XText> */}
        <HStack w='full'>
          <HStack flex={1}>
            <XText variant='inactive'>{`${xFmt.formatCurrency(selectedAddOn.price_with_vat)}/รอบบิล x ${addOn.billing_cycle} รอบบิล x ${
              addOn.qty
            }`}</XText>
          </HStack>
          <VStack w='24' justifyContent='flex-end'>
            <XText bold textAlign='right'>
              {xFmt.formatCurrency(price)}
            </XText>
          </VStack>
        </HStack>
      </VStack>
    )
  }

  _renderResult = () => {
    const { selectedAddOnlist } = this.state
    const isDisabled = !this._hasSelectedAddOn()
    if (_.isNil(selectedAddOnlist) || selectedAddOnlist.length === 0 || selectedAddOnlist[0].sku === null || isDisabled) {
      return null
    }
    const result = this._getSumResult()
    return (
      <VStack bgColor={COLORS.BG_LIGHT_GREY} p='2' w='full'>
        <XText variant='active' bold>
          สรุป
        </XText>
        {selectedAddOnlist.map((addOn) => this._renderResultAddOn(addOn))}
        {this._renderSummaryAddOnPackage()}
        <HStack w='full'>
          <HStack flex={1} />
          <VStack w='24' justifyContent='flex-end'>
            <XText bold fontSize='xl' textAlign='right'>
              {xFmt.formatCurrency(result)}
            </XText>
            <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' />
            <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='3' mt='1' />
          </VStack>
        </HStack>
      </VStack>
    )
  }

  _renderDoNotBuyThisPackage = () => (
    <XCard p='2' w='full'>
      <VStack w='full' alignItems='center' justifyContent='center'>
        <XText>แพ็กเกจของคุณไม่สามารถเลือกแพ็กเสริมนี้ได้</XText>
      </VStack>
    </XCard>
  )

  _renderBody = () => {
    const { selectedPackage, addOnList } = this.state
    // console.log('addOnList / => ', addOnList)
    if (_.isNil(selectedPackage)) {
      return null
    }
    if (_.isNil(addOnList) || addOnList.length === 0) {
      return this._renderDoNotBuyThisPackage()
    }
    return (
      <XCard p='2' w='full'>
        <VStack w='full'>
          {this._renderSelectedAddOn()}
          {this._renderBillingCycle()}
          {this._renderSelectedOrderQty()}
          {this._renderResult()}
        </VStack>
      </XCard>
    )
  }

  _renderOrderCountHistory = () => {
    const params = this._getParams()
    const { orderCountHistory } = params
    // console.log('orderCountHistory => ', orderCountHistory)
    if (_.isNil(orderCountHistory)) {
      return null
    }
    let countNumber = 0
    orderCountHistory.forEach((order) => {
      const { order_count } = order
      if (order_count === 0) {
        countNumber += 1
      }
    })
    if (countNumber === orderCountHistory.length) {
      return null
    }
    return (
      <XCard p='2' w='full' mt='2' h='32'>
        <XOrderCountHistory orderCountHistory={orderCountHistory} />
      </XCard>
    )
  }

  _RENDER_DATA_ORDER = (title: string, value: number) => {
    const { addOnList, selectedPackage } = this.state
    if (_.isNil(addOnList) || _.isNil(selectedPackage)) {
      return null
    }
    let unitLabel = 'ออเดอร์'
    if (addOnList[0].sku !== null) {
      unitLabel = this._getLabelUnit(addOnList[0]?.item_subtype)
    }
    return (
      <HStack w='full'>
        <HStack flex={3}>
          <XText variant='inactive'>{title}</XText>
        </HStack>
        <HStack flex={2} justifyContent={'flex-end'} alignItems='center'>
          <XText variant='inactive' w='16' textAlign='right'>{`${xFmt.formatDecimal(value)}`}</XText>
          <XText variant='inactive' ml='2'>{`${unitLabel}`}</XText>
        </HStack>
      </HStack>
    )
  }

  _renderCurrentView = () => {
    const { addOnList, selectedPackage, subscriptionPackageList } = this.state
    if (_.isNil(addOnList) || _.isNil(selectedPackage)) {
      return null
    }
    const addOnCurrents = this._getAddOnPackageInCurrentPackageBillingCycle()
    if (_.isNil(addOnCurrents) || addOnCurrents.length === 0) {
      return this._RENDER_DATA_ORDER(`เดิมแพ็กเสริมไม่มี`, 0)
    }
    let itemSubType = 'order_count_quota'
    if (addOnList[0].sku !== null) {
      itemSubType = addOnList[0].item_subtype
    }
    return (
      <VStack>
        {addOnCurrents.map((CURRENT) => {
          const packageJson = util.getSubscriptionPackageJsonBySku(CURRENT.sku, subscriptionPackageList)
          // console.log('packageJson / => ', packageJson)
          if (_.isNil(packageJson)) {
            return null
          }
          const { name } = packageJson
          const unit = CURRENT.data_json[itemSubType] * CURRENT.qty
          // console.log('CURRENT / => ', CURRENT)
          return this._RENDER_DATA_ORDER(`เดิม${name} x ${CURRENT.qty}`, unit)
        })}
      </VStack>
    )
  }

  _renderSummaryAddOnPackage = () => {
    const { subscription } = this.props
    const { addOnList, selectedPackage } = this.state
    if (_.isNil(addOnList) || _.isNil(selectedPackage)) {
      return null
    }
    // const subscriptionJs = subscription.toJS()

    // console.log('selectedPackage / => ', selectedPackage)
    // console.log('addOnList / => ', addOnList)
    // console.log('selectedAddOnlist / => ', selectedAddOnlist)
    let unitLabel = 'ออเดอร์'
    if (addOnList[0].sku !== null) {
      unitLabel = this._getLabelUnit(addOnList[0]?.item_subtype)
    }
    const oldUnitCount = this._getTotalCountUnitInCurrentPackageBillingCycle()
    const newUnitCount = this._getSumTotalUnitSelectedAddOn()
    // console.log('oldUnitCount / => ', oldUnitCount)
    // console.log('newUnitCount / => ', newUnitCount)
    return (
      <VStack w='full' mt='2'>
        <XText bold>{`รวม${unitLabel}`}</XText>

        {this._RENDER_DATA_ORDER('รวมซื้อเพิ่ม', newUnitCount)}
        {this._renderCurrentView()}
        <HStack borderStyle='dotted' borderBottomWidth='1' flex={1} />
        {this._RENDER_DATA_ORDER('รวมเหลังซื้อ', oldUnitCount + newUnitCount)}
      </VStack>
    )
  }

  render() {
    return (
      <XContainer>
        {this._renderHeader()}
        <XContent p='1' style={{ backgroundColor: COLORS.BG_LIGHT_GREY }}>
          {this._renderBody()}
          {this._renderOrderCountHistory()}
        </XContent>
        {this._renderFooter()}
      </XContainer>
    )
  }
}
